import { Message, MessageBox } from 'element-ui'
import store from '@/store/index'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Moment from 'moment'
/**
 * @Description: LY公共组件类
 * @author Lu Jie
 * @date 2020/7/8
 */
const LYCom = {}

//#region Ajax请求

/**
 * Ajax请求配置
 * @type {{Timeout: number, ProcessData: boolean, SvrRoot: string}}
 */
LYCom.CallBizCfg = {
    SvrRoot: "https://sxxf.lanyunxinli.cn/JsonSvc/", //业务服务地址
    // SvrRoot: 'http://192.168.0.101:8095/JsonSvc/', //业务服务地址
    QrcodeUrl: 'https://sxxf.lanyunxinli.cn/mobile/',
    // FileRoot: "http://39.99.191.195:8096", //附件服务地址
    FileRoot: 'https://sxxf.lanyunxinli.cn/Attachment', //附件服务地址
    // FileRoot: "http://192.168.0.101:8096/", //附件服务地址
    ProcessData: true,
    Timeout: 200000000
}


// 左侧组织机构树形配置
LYCom.leftOrgTreeProps = {
        children: "children",
        label: "name",
    },

    /**
     * 格式化请求参数
     * @param arg 请求参数
     * @returns {*}
     * @constructor
     */
    LYCom.FormatAjaxArg = function(arg) {
        if (arg != null && arg != undefined) {
            for (var x in arg) {
                arg[x] = JSON.stringify(arg[x])
            }
        }
        return arg
    }

/**
 * 重置请求配置
 * @constructor
 */
LYCom.ResetCallBizCfg = function() {
    this.CallBizCfg.ProcessData = true
    this.CallBizCfg.Timeout = 200000000
}

/**
 * 同步请求
 * @param bizName 请求业务名
 * @param funName 请求函数名
 * @returns {*}
 * @constructor
 */
LYCom.CallBiz = function(bizName, funName) {
    var data = null
    if (arguments != null && arguments.length > 2) {
        if (this.CallBizCfg.ProcessData) {
            data = {}
            for (var i = 2, len = arguments.length; i < len; i++) {
                data['arg' + (i - 2)] = arguments[i]
            }
            data = this.FormatAjaxArg(data)
        } else {
            data = arguments[2]
        }
    }
    var rtnData = null
    $.ajax({
        url: this.CallBizCfg.SvrRoot + bizName + '.' + funName,
        type: 'POST',
        async: false,
        data: data,
        processData: this.CallBizCfg.ProcessData,
        timeout: this.CallBizCfg.Timeout,
        dataType: 'json',
        success: function(data, textStatus, jqXHR) {
            rtnData = data
        },
        error: function(xhr, textStatus) {
            if (textStatus == 'timeout') {
                throw new Error('调用超时!')
            } else {
                if (xhr.responseText == 'token失效' || xhr.responseText == 'token不能为空') {
                    MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        store.dispatch('FedLogOut').then(() => {
                            location.reload() // 为了重新实例化vue-router对象 避免bug
                        })
                    })
                } else {
                    throw new Error('BizSvrErr:' + xhr.responseText)
                }
            }
        }
    })
    this.ResetCallBizCfg()
    return rtnData
}

/**
 * 异步请求
 * @param onAsynCallBack 回调函数
 * @param bizName 请求地址
 * @constructor
 */
LYCom.AsynCallBiz = function(onAsynCallBack, bizName) {
    var data = null
    if (arguments != null && arguments.length > 2) {
        if (this.CallBizCfg.ProcessData) {
            data = {}
            for (var i = 2, len = arguments.length; i < len; i++) {
                data['arg' + (i - 2)] = arguments[i]
            }
            data = this.FormatAjaxArg(data)
        } else {
            data = arguments[2]
        }
    }
    $.ajax({
        url: this.CallBizCfg.SvrRoot + bizName,
        type: 'POST',
        async: true,
        data: data,
        processData: this.CallBizCfg.ProcessData,
        timeout: this.CallBizCfg.Timeout,
        dataType: 'json',
        success: function(data, textStatus, jqXHR) {
            onAsynCallBack({ rtnObj: data })
        },
        error: function(xhr, textStatus) {
            if (textStatus == 'timeout') {
                onAsynCallBack({ err: '调用超时!' })
            } else {
                if (xhr.responseText == 'token失效' || xhr.responseText == 'token不能为空') {
                    MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        store.dispatch('FedLogOut').then(() => {
                            location.reload() // 为了重新实例化vue-router对象 避免bug
                        })
                    })
                } else {
                    onAsynCallBack({ err: 'BizSvrErr:' + xhr.responseText })
                }

            }
        }
    })
    this.ResetCallBizCfg()
}

//#endregion

//#region Token管理

const TokenKey = 'token'

/**
 * 获取Token
 * @constructor
 */
LYCom.GetToken = function() {
    return sessionStorage.getItem(TokenKey)
}

/**
 * 保存Token
 * @param token 令牌
 * @constructor
 */
LYCom.SetToken = function(token) {
    sessionStorage.setItem(TokenKey, token)
}

/**
 * 移除Token
 * @constructor
 */
LYCom.RemoveToken = function() {
    sessionStorage.removeItem(TokenKey)
}

//#endregion

//#region 树形结构方法

/**
 * 递归查询数据
 * @param arr 源数据
 * @param child 子节点标识
 * @param fn 判断回调
 * @param result 结果
 * @constructor
 */
LYCom.Find = function(arr, child, fn, result) {
    arr.forEach(item => {
        if (fn(item)) {
            result.push(item)
        } else {
            if (item[child] && item[child] != null && item[child].length > 0) {
                LYCom.Find(item.Children, child, fn, result)
            }
        }
    })
}


//#endregion

//#region 字符串

/**
 * 判断字符串是否为空
 * @param str 字符串
 * @returns {boolean} 是否为空
 * @constructor
 */
LYCom.StringIsEmpty = function(str) {
    if (typeof str == null || str == '' || str == 'undefined') {
        return true
    } else {
        return false
    }
}

//#endregion

//#region 身份证

/**
 * 身份证号合法性验证
 * 支持地址编码、出出生日期期、校验位验证
 * @param code 身份证号码
 * @returns {boolean} 是否合法
 * @constructor
 */
LYCom.IdentityCodeValid = function(code) {
    var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
    }
    var tip = ''
    var pass = true
        //验证身份证格式（6个地区编码，8位出出生日期期，3位顺序号，1位校验位）
    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = '身份证号格式错误'
        pass = false
    } else if (!city[code.substr(0, 2)]) {
        tip = '地址编码错误'
        pass = false
    } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
            code = code.split('')
                //∑(ai×Wi)(mod 11)
                //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
                //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
            var sum = 0
            var ai = 0
            var wi = 0
            for (var i = 0; i < 17; i++) {
                ai = code[i]
                wi = factor[i]
                sum += ai * wi
            }
            var last = parity[sum % 11]
            if (parity[sum % 11] != code[17]) {
                tip = '校验位错误'
                pass = false
            }
        }
    }
    return pass
}

/**
 * 根据身份证号码获取出出生日期期
 * @param idCard 身份证号码
 * @returns {string} 出出生日期期
 * @constructor
 */
LYCom.GetBirthdayByIdCard = function(idCard) {
    var birthday = ''
    if (idCard != null && idCard != '') {
        if (idCard.length == 15) {
            birthday = '19' + idCard.substr(6, 6)
        } else if (idCard.length == 18) {
            birthday = idCard.substr(6, 8)
        }

        birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
    }

    return birthday
}


//时长转换
LYCom.formatTime = function(value) {
    if (value == undefined) {
        value = 0;
    }
    let second = parseInt(value); // 秒
    let min = 0; // 分
    let hour = 0; // 小时
    if (second >= 60) {
        min = parseInt(second / 60);
        second = parseInt(second % 60);
        if (min >= 60) {
            hour = parseInt(min / 60);
            min = parseInt(min % 60);
        }
    }
    let result = "";
    if (second >= 0) {
        result += parseInt(second) + "秒"
    }
    if (min == 0 && hour == 0 && second == 0) {
        result = "";
    }
    if (min > 0) {
        result = "" + parseInt(min) + "分钟" + result;
    }
    if (hour > 0) {
        result = "" + parseInt(hour) + "小时" + result;
    }
    return result;
}




/**
 * 根据身份证号码获取年龄
 * @param identityCard 身份证号码
 * @returns {number} 年龄
 * @constructor
 */

LYCom.GetAgeByIdCard = function(identityCard) {
    var strBirthday = LYCom.GetBirthdayByIdCard(identityCard)
    if (strBirthday == '') {
        return 0
    }

    //时间字符串里，必须是“/”
    var birthDate = new Date(strBirthday)
    var nowDateTime = new Date()
    var age = nowDateTime.getFullYear() - birthDate.getFullYear()
        //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--
    }

    return age
}

/**
 * 根据身份证号获取性别
 * @param idCard 身份证号码
 * @returns {number} 性别（1：男；2：女）
 * @constructor
 */
LYCom.GetSexByIdCard = function(idCard) {
    if (LYCom.StringIsEmpty(idCard)) {
        return -1
    }

    if (parseInt(idCard.substr(16, 1)) % 2 == 1) {
        return 1
    } else {
        return 2
    }
}

//#endregion

//#region 时间转化

/**
 * 格式化时间
 * @param date 时间
 * @param fmt 格式化字符串
 * @returns {*} 格式化时间
 */
LYCom.FormatDate = function(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
    }
    return fmt
}
LYCom.GetCurrentSchoolYear = function() {
        let date = new Date()
        let year = date.getFullYear(),
            month = date.getMonth()
        if (month > 6) {
            return year
        }
        return year - 1
    }
    //#endregion

/**
 * 时间格式化
 * @param fmt
 * @returns {*}
 */
Date.prototype.format = function(fmt) {
        var o = {
            'M+': this.getMonth() + 1, //月份
            'd+': this.getDate(), //日
            'h+': this.getHours(), //小时
            'm+': this.getMinutes(), //分
            's+': this.getSeconds(), //秒
            'q+': Math.floor((this.getMonth() + 3) / 3), //季度
            'S': this.getMilliseconds() //毫秒
        }
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
        }
        return fmt
    }
    // 获取今年时间 和当前时间
LYCom.getCurrentTime = function() {
        let date = new Date();
        let oYear = date.getFullYear(),
            oMonth = date.getMonth() + 1,
            oDate = date.getDate() + 1, // +1 确保当天记录可查询
            time = {
                startTime: oYear + '-1-1',
                currentTime: oYear + '-' + oMonth + '-' + oDate,
                endTime: oYear + '-12-31'
            }
        return time
    }
    // 获取指定时间格式  YYYY-MM-DD HH:mm:ss
LYCom.momentDate = function(date, moment = "YYYY-MM-DD") {
        if (date) {
            return Moment().format(moment)
        } else {
            return "";
        }
    },
    LYCom.MMPTDegreeColorArr = ['#c0392b', '#e74c3c', '#d35400', '#3bafda', '#8CC152']
LYCom.GetMMPTDegreeColor = function(degree, description) {
    if (degree == 1) {
        return LYCom.MMPTDegreeColorArr[0]
    } else if (degree == 5) {
        return LYCom.MMPTDegreeColorArr[4]
    }
    if (description) {
        if (description.indexOf('轻') !== -1) {
            return LYCom.MMPTDegreeColorArr[3]
        } else if (description.indexOf('中') !== -1) {
            return LYCom.MMPTDegreeColorArr[2]
        } else if (description.indexOf('重') !== -1) {
            return LYCom.MMPTDegreeColorArr[0]
        } else if (description.indexOf('无') !== -1 || description.indexOf('正常') !== -1) {
            return LYCom.MMPTDegreeColorArr[4]
        }
    }
    return LYCom.MMPTDegreeColorArr[degree - 1]
}

LYCom.GetDegreeColor = function(degree) {
        return LYCom.MMPTDegreeColorArr[5 - degree]
    }
    // 自定义树形结构
LYCom.normalizer = function(node) {
        if (node.children && node.children != null && node.children.length > 0) {
            return {
                id: node.organization_id,
                label: node.name,
                children: node.children,
            };
        } else {
            return {
                id: node.organization_id,
                label: node.name,
                children: delete node.children,
            };
        }
    },
    // 删除树形结构组织空children
    LYCom.normalizer2 = function(node) {
        if (
            node.children == undefined ||
            node.children == null ||
            node.children.length == 0
        ) {
            delete node.children;
        }
    },
    // 默认展开左侧组织机构第一层
    LYCom.setLeftExpandedKeys = function(array, currentData) {
        if (array && array.length > 0) {
            for (let i = 0; i < array.length; i++) {
                currentData.push(array[i].organization_id);

            }
        }
    },
    // 获取性别中文名称
    LYCom.getSexName = function(sex) {
        if (sex == 0) {
            return '未知'
        } else if (sex == 1) {
            return '男'
        } else if (sex == 2) {
            return '女'
        }
    },
    LYCom.getTaskType = function(taskType) {
        switch (taskType) {
            case 1:
                return '心理测评任务'
                break;
            case 2:
                return '心理训练任务'
                break;
            case 3:
                return '心理教学任务'
        }
    },
    // 默认全选组织机构--全选只返回父级节点id
    LYCom.checkedAllNode = function(array, data) {
        let self = this;
        if (array && array.length > 0) {
            for (let i = 0; i < array.length; i++) {
                const el = array[i];
                data.push(el.organization_id);
                // if (el.children && el.children.length > 0) {
                //     self.checkedAllNode(el.children, data);
                // }
            }
        }
    },
    // 默认全选组织机构-- 全选返回子父节点id
    LYCom.checkedAllNode2 = function(array, data) {
        let self = this;
        if (array && array.length > 0) {
            for (let i = 0; i < array.length; i++) {
                const el = array[i];
                data.push(el.organization_id);
                if (el.children && el.children.length > 0) {
                    self.checkedAllNode2(el.children, data);
                }
            }
        }
    },
    // 左侧组织机构树点击事件
    LYCom.leftTreeCheck = function(_this) {
        let checkedNodes = _this.$refs.leftOrgTreeRef.getCheckedNodes(true);
        let newArr = checkedNodes.concat();
        let arr = [];
        for (let i = 0; i < checkedNodes.length; i++) {
            for (let j = 0; j < newArr.length; j++) {
                if (checkedNodes[i].ParentID != newArr[j].organization_id) {
                    if (arr.indexOf(checkedNodes[i].organization_id) == -1) {
                        arr.push(checkedNodes[i].organization_id);
                    }
                }
            }
        }
        _this.checkedNodes = arr;
    },


    //#endregino
    // base64 转二进制流
    LYCom.Base64toBlob = function(base64, type) {
        // 将base64转为Unicode规则编码
        let bstr = atob(base64, type),
            n = bstr.length,
            u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n) // 转换编码后才可以使用charCodeAt 找到Unicode编码
        }
        return new Blob([u8arr], {
            type,
        })
    }
    //图片格式转换方法
LYCom.dataURLToBlob = function(dataurl) {
        let arr = dataurl.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    },

    // html转图片下载
    LYCom.exportImg = function(fileName) {
        let a = document.createElement("a");
        html2canvas(document.querySelector("#printDom")).then((canvas) => {
            let dom = document.body.appendChild(canvas);
            dom.style.display = "none";
            a.style.display = "none";
            document.body.removeChild(dom);
            let blob = LYCom.dataURLToBlob(dom.toDataURL("image/png"));
            a.setAttribute("href", URL.createObjectURL(blob));
            //这块是保存图片操作  可以设置保存的图片的信息
            a.setAttribute("download", fileName + ".png");
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(blob);
            document.body.removeChild(a);
        });
    }

// html转pdf下载
LYCom.exportPdf = function(fileName) {
    let a = document.createElement("a");
    html2canvas(document.querySelector("#printDom"), {
        scale: 4
    }).then((canvas) => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        a.style.display = "none";
        var contentWidth = canvas.width - 20;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 572.28) * 821.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 20;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 557.28;
        var imgHeight = (572.28 / contentWidth) * contentHeight;

        var pageData = canvas.toDataURL("image/JPEG", 1.0);

        var pdf = new jsPDF("", "pt", "a4");

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
            pdf.addImage(pageData, "JPEG", 20, 20, imgWidth, imgHeight);
        } else {
            while (leftHeight > 0) {
                pdf.addImage(pageData, "JPEG", 20, position, imgWidth, imgHeight);
                leftHeight -= pageHeight;
                position -= 841.89;
                //避免添加空白页
                if (leftHeight > 0) {
                    pdf.addPage();
                }
            }
        }
        pdf.save(fileName + ".pdf");
    });
}

export default LYCom


//////////////////
// WEBPACK FOOTER
// ./static/js/LYCom.js
// module id = ZDvl
// module chunks = 62